import React, { useEffect, useState } from 'react'
import Footer from '../components/footer/Footer';
import useStyles from '../styles/credit_card';
import { styled } from '@mui/system'
import { Grid } from '@mui/material';
import Popup from '../components/appbar/Popup';
import { Link } from 'react-router-dom';
import { FaRegCreditCard } from "react-icons/fa";
import { CgFileDocument } from "react-icons/cg";
import * as ROUTES from "../constants/routes"




const CreditCardContainer: React.FC = () => {
    const classes = useStyles()

    useEffect(() => {
        const sectionEl = document.getElementById("credit-card-hero")
        const handleScroll = () => {
            const position = 217.168 + window.scrollY * 0.65
            if(sectionEl){
                if(position >= 500){
                    sectionEl.style.backgroundPosition = `0px -500px`
                }else{
                    sectionEl.style.backgroundPosition = `0px -${position}px`
                }
            }
            
        };
    
        window.addEventListener('scroll', handleScroll);
    
        return () => window.removeEventListener('scroll', handleScroll);
      }, []);
    const Hero = styled('section')(({ theme }) => ({
        position: 'relative',
        backgroundImage: 'url(imgs/credit_card.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: '0px -217.168px',
        padding: '150px 0px',
        top: '-100px',
        marginBottom: '-100px',
        textShadow: 'none !important',
        borderBottom: 'none',
        backgroundColor: 'transparent',
        backgroundAttachment: 'fixed',
        backgroundRepeat: 'no-repeat',
        transition: 'all 0.17s linear !important',

        [theme.breakpoints.down('md')]: {
            padding: '100px 0px',
        },
        [theme.breakpoints.down('md')]: {
            padding: '60px 0px',
        },
    }));
    const MainContent = styled('section')(({ theme }) => ({
        position: 'relative',
        overflow: 'hidden',
        background: '#fff',
        margin: '0',
    }));

    const [needed, setNeeded] = useState<boolean>(false)
    const [name, setName] = useState<string>('')
    const handleLink = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault()

        setName('credit_card')
        setNeeded(true)
    }

    
  return (
    <>
        <main>
            <Hero id='credit-card-hero'>
                <div className={classes.heroInner}>
                    <h1 className={classes.heroInnerH1}>Credit Cards</h1>
                </div>
            </Hero>

            <MainContent>
                <div className={classes.mainContentInner}>
                        <div className={classes.mainContentInnerContainer}>
                            <div style={{clear: 'both', float: 'none', paddingRight: '0', position: 'relative', width: '100%'}}>
                                
                                <div style={{marginBottom: '4rem'}}>
                                    <Grid container style={{justifyContent: 'space-between'}}>
                                        <Grid item xs={12} sm={5.65}>
                                            <div id='card-holder' className={classes.pageCard}>
                                                <div id='card-icon-holder' className={classes.cardIconHolder}>
                                                    <div id='card-icon-icon' className={classes.cardIcon}>
                                                    <i className="fa fa-file-text-o" style={{fontSize: '2.5rem'}}></i>
                                                    </div>
                                                </div>
                                                
                                                <Link className={classes.cardLink} to={ROUTES.LOAN_APPLICATION}>Apply For Credit Card</Link>
                                                <h3 className={classes.cardH3}>Apply Online from Anywhere</h3>
                                                
                                            </div>
                                        </Grid>
                                        <Grid item xs={12} sm={5.65}>
                                            <div id='card-holder2' className={classes.pageCard}>
                                                <div id='card-icon-holder2' className={classes.cardIconHolder}>
                                                    <div id='card-icon-icon2' className={classes.cardIcon}>
                                                        <i className="fa fa-credit-card" style={{fontSize: '2.5rem'}}></i>
                                                    </div>
                                                </div>

                                                <Link className={classes.cardLink} onClick={(e)=>handleLink(e)} to='https://www.eZCardInfo.com'>eZCardInfo</Link>
                                                <h3 className={classes.cardH3}>Access Your Credit Card Easily</h3>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </div>


                                <div className={classes.pageTitle}>
                                    <h2 className={classes.pageTitleH2}>VISA Account Types</h2>
                                </div>

                                <ul className={classes.paragraph} style={{fontSize: '1rem', paddingLeft: '20px',}}>
                                    <li>The Visa Classic Card has a 12.00% interest rate and is eligible for qualified members.</li>
                                    <li>The Visa Classic Preferred Card has a 10.50% interest rate and is eligible to qualified full-house members. Full-house members shall be defined as members who maintain a share draft and debit card account.</li>
                                </ul>

                            </div>
                        </div>
                </div>


            </MainContent>

    


            <Footer />
        </main>
        <Popup needed={needed} setNeeded={setNeeded} name={name} setName={setName}/>
    </>
  )
}

export default CreditCardContainer
